import { StackProps, Stack } from "./Stack"

export interface FormStackProps extends StackProps {}

export const FormStack = (props: StackProps) => {
  return <Stack fill distance={6} {...props} />
}
